import { StringIdentifierSerializer } from './string-identifier-serializer';

export function stringIdentifierDateSerializer<ExtendedType extends Date = Date>(
    extraConversion?: (parsed: Date) => ExtendedType,
): StringIdentifierSerializer<ExtendedType> {
    return {
        deserialize(stringVal) {
            const parsed = new Date(parseInt(stringVal, 10));

            if (extraConversion) {
                return extraConversion(parsed);
            }
            return parsed as ExtendedType;
        },
        serialize(val) {
            return val.getTime().toString();
        },
    };
}
